const Header = ({
  live, ended, stale,
}: { live?: boolean; ended?: boolean; stale?: boolean }) => {
  return (
    <>
      {ended ? (
        <div className="absolute right-4 top-4 z-30 flex items-center gap-2 rounded-full bg-white/95 px-3 py-2 shadow-card lg:right-[22px] lg:top-[22px] lg:px-3.5">
          <span className="h-2 w-2 rounded-full bg-ro-passed lg:h-[9px] lg:w-[9px]" />
          <span className="text-xs font-extrabold tracking-[0.08em] text-ro-stone lg:text-[13px]">
            <span className="lg:hidden">ENDED</span>
            <span className="hidden lg:inline">TRIP ENDED</span>
          </span>
        </div>
      ) : null}

      {!ended && live && stale ? (
        <div className="absolute right-4 top-4 z-30 flex items-center gap-2 rounded-full bg-white/95 px-3 py-2 shadow-card lg:right-[22px] lg:top-[22px] lg:px-3.5">
          <span className="h-2 w-2 rounded-full bg-ro-passed lg:h-[9px] lg:w-[9px]" />
          <span className="text-xs font-extrabold tracking-[0.08em] text-ro-stone lg:text-[13px]">
            <span className="lg:hidden">DELAYED</span>
            <span className="hidden lg:inline">SIGNAL DELAYED</span>
          </span>
        </div>
      ) : null}

      {!ended && live && !stale ? (
        <div className="absolute right-4 top-4 z-30 flex items-center gap-2 rounded-full bg-white/95 px-3 py-2 shadow-card lg:right-[22px] lg:top-[22px] lg:px-3.5">
          <span className="h-2 w-2 animate-ro-blink rounded-full bg-ro-red lg:h-[9px] lg:w-[9px]" />
          <span className="text-xs font-extrabold tracking-[0.08em] text-ro-black lg:text-[13px]">
            <span className="lg:hidden">LIVE</span>
            <span className="hidden lg:inline">LIVE TRACKING</span>
          </span>
        </div>
      ) : null}
    </>
  );
};

export default Header;
